import React, { useEffect, useState } from "react";
import { Skeleton } from "primereact/skeleton";
import "./SegmentInfluencingSection.scss";
import { useSelector } from "react-redux";
import {
  SEGMENT_INFLUENCING_FACTOR,
  SUBSCRIPTION,
} from "../../../../../../utils/global";
import {
  calculateAPValue,
  formatToDollar,
  getArrowIndicatorClass,
  getBase64FromImage,
  getBase64FromSource,
  getDifferenceClass,
  getDifferenceClassForFHS,
} from "../../../../../../utils/Utils";
import CustomTooltip from "../../../../../Common/Tooltip/CustomTooltip";
import {
  useGetInsightsAndRecommendationQuery,
  useQueryStateInsightsAndRecommendation,
} from "../../../../../../rtk-query/features/insightsAndRecommendation/insightsAndRecommendationSlice";

export const generateSegmentInfluencingData = async (selectedSegmentData) => {
  const mergedData = await Promise.all(
    SEGMENT_INFLUENCING_FACTOR.map(async (item1) => {
      const item2 = selectedSegmentData?.find((item) => item.key === item1.key);
      const base64Icon = await getBase64FromSource(item1.icon);
      return {
        ...item1,
        ...item2,
        base64Icon,
      };
    }),
  );

  return mergedData.toSorted((a, b) => a.order - b.order);
};

const SegmentInfluencingSection = ({ showAPValue }) => {
  const [segmentInfluencingObj, setSegmentInfluencingObj] = useState(null);
  const fhsDrilldownReducer = useSelector((state) => state.fhsDrilldownReducer);
  const selectedbankMetrics = useSelector(
    (state) => state.infiniteBankPerformanceMetricsReducer,
  );

  // const { payload: FHSSummary } = useSelector((state) =>
  //   selectFinancialHealthScoreSummary(state),
  // );

  useEffect(() => {
    // if (fhsDrilldownReducer?.drilldownCohort?.segments_influencing) {
    //   setSegmentInfluencingObj(
    //     SEGMENT_INFLUENCING_FACTOR?.map((segment) => {
    //       const existingData = segmentInfluencingObj?.find(
    //         (item) => item.key === segment.key,
    //       );
    //       const segmentData =
    //         fhsDrilldownReducer?.drilldownCohort?.segments_influencing[
    //           segment.key
    //         ];
    //       return {
    //         ...existingData,
    //         ...segment,
    //         ...segmentData,
    //       };
    //     }),
    //   );
    // } else {
    //   setSegmentInfluencingObj(null);
    // }

    //old working code
    // if (
    //   selectedbankMetrics?.selectedBankMetricData?.groupedResult
    //     ?.segment_influencing
    // ) {
    //   const mergedData = SEGMENT_INFLUENCING_FACTOR.map((item1) => {
    //     const item2 =
    //       selectedbankMetrics?.selectedBankMetricData?.groupedResult?.segment_influencing.find(
    //         (item) => item.key === item1.key,
    //       );
    //     return {
    //       ...item1,
    //       ...item2,
    //     };
    //   });
    //   let segmentData = mergedData.toSorted((a, b) => {
    //     return a.order - b.order;
    //   });

    //   setSegmentInfluencingObj(segmentData);
    // } else {
    //   setSegmentInfluencingObj(null);
    // }

    //New code
    const fetchData = async () => {
      const segmentDataRaw =
        // selectedbankMetrics?.selectedBankMetricData?.groupedResult
        //   ?.segment_influencing;
        selectedbankMetrics?.selectedBankMetricData?.growth_metrics; //New code - 28/05/2025

      if (segmentDataRaw) {
        const segmentData =
          await generateSegmentInfluencingData(segmentDataRaw);
        setSegmentInfluencingObj(segmentData);
      } else {
        setSegmentInfluencingObj(null);
      }
    };

    fetchData();
  }, [selectedbankMetrics]);

  return (
    segmentInfluencingObj && (
      <div className="row segments-section p-8" id="segments-section">
        <div className="col-md-6">
          <div className="fw-bolder text-dark w-100 fs-title">
            {`Institution Growth Forecast for ${
              selectedbankMetrics?.selectedBankMetricData?.forecast_quarter
            }`}
          </div>
        </div>
        <div className="col-md-6">
          <span className="remark">Dollar amount in thousands</span>
        </div>
        <div className="col-md-12 row g-5 m-0 p-0">
          {segmentInfluencingObj?.map((segment) => {
            return (
              <div key={segment.key} className="col-md-4 segments-wrapper">
                <div className="segment">
                  <div className="header-content d-flex justify-content-between">
                    <div className="context">
                      <div className="fs-subtitle">{segment?.title}</div>
                      <span className="fs-subdesc">{segment?.description}</span>
                    </div>
                    <div className="icon">
                      <img alt="icon" src={segment?.icon} />
                    </div>
                  </div>

                  <span className="fs-value mt-9 h-100 align-content-end current_value">
                    {segment?.symbol === "$" && segment?.symbol}
                    {segment?.symbol === "$" && formatToDollar(segment.current)}
                    {segment?.symbol === "%" &&
                      Number(segment.value).toFixed(2)}
                    {segment?.symbol === "%" && segment?.symbol}

                    <CustomTooltip text="Forecast Variance" placement="top">
                      <span
                        className={`badge trend align-middle arrow_value ${getDifferenceClass(
                          segment?.forecasted,
                          segment?.current,
                          segment?.is_reverse,
                        )}`}
                      >
                        {Math.abs(segment?.forecasted_trend ?? 0)}%
                      </span>
                    </CustomTooltip>
                  </span>

                  <div className="footer-content mt-2">
                    {/* <CustomTooltip
                    text={`${getDifferenceMessage(
                      segment?.forcasted_trend ?? 0,
                      Math.abs(segment?.forecasted - segment?.current),
                    )}`}
                    placement="top"
                  >
                    <span
                      className={`badge trend ms-0 ${getDifferenceClass(
                        segment?.forcasted_trend,
                        segment?.is_reverse,
                      )}`}
                    >
                      {Math.abs(segment?.forcasted_trend ?? 0)}%
                    </span>
                  </CustomTooltip>
                  {fhsDrilldownReducer?.loadingChanges ? (
                    <Skeleton className="skeleton-badge"></Skeleton>
                  ) : (
                    <CustomTooltip text="Autopilot Forecast" placement="top">
                      <span className={`badge cohort_average`}>
                        {segment?.symbol === "$" && segment?.symbol}
                        {segment?.symbol === "$" &&
                          formatToDollar(Math.abs(segment.ap_used))}
                        {segment?.symbol === "%" &&
                          Number(segment.ap_used).toFixed(2)}
                        {segment?.symbol === "%" && segment?.symbol}
                      </span>
                    </CustomTooltip>
                  )} */}

                    {fhsDrilldownReducer?.loadingChanges ? (
                      <Skeleton className="skeleton-badge"></Skeleton>
                    ) : (
                      <>
                        {/* old code */}
                        {/* <CustomTooltip
                        text={`${selectedbankMetrics?.selectedBankMetricData?.ungroupedResult?.forecast_quarter} Forecast`}
                        placement="top"
                      >
                        <span className={`badge cohort_average`}>
                          {segment?.symbol === "$" && segment?.symbol}
                          {segment?.symbol === "$" &&
                            formatToDollar(segment.forecasted)}
                          {segment?.symbol === "%" &&
                            Number(segment.ap_used).toFixed(2)}
                          {segment?.symbol === "%" && segment?.symbol}
                        </span>
                      </CustomTooltip> */}

                        {/* new code */}
                        <CustomTooltip
                          text={`Forecasted Growth ${Math.abs(
                            segment?.forecasted_trend ?? 0,
                          )}%`}
                          placement="top"
                        >
                          <span className={`badge cohort_average`}>
                            <span
                              className={`${getArrowIndicatorClass("isForcasted", showAPValue, segment)}`}
                            ></span>
                            <span className="align-middle">
                              {segment?.symbol === "$" && segment?.symbol}
                              {segment?.symbol === "$" &&
                                formatToDollar(segment.forecasted)}
                              {segment?.symbol === "%" &&
                                Number(segment.ap_used).toFixed(2)}
                              {segment?.symbol === "%" && segment?.symbol}
                            </span>
                          </span>
                        </CustomTooltip>

                        {/* old code */}
                        {/* <CustomTooltip
                        text={`${selectedbankMetrics?.selectedBankMetricData?.ungroupedResult?.forecast_quarter} Autopilot Value`}
                        placement="top"
                      >
                        <span
                          className={
                            showAPValue
                              ? "badge cohort_average autopilot_variance"
                              : "d-none"
                          }
                        >
                          {segment?.symbol === "$" && segment?.symbol}
                          {segment?.symbol === "$" &&
                            formatToDollar(segment.ap_used)}
                          {segment?.symbol === "%" &&
                            Number(segment.ap_used).toFixed(2)}
                          {segment?.symbol === "%" && segment?.symbol}
                        </span>
                      </CustomTooltip> */}

                        {/* new code */}
                        <CustomTooltip
                          text={`Growth with Autopilot ${Math.abs(
                            segment?.autopilot_trend ?? 0,
                          )}%`}
                          placement="top"
                        >
                          <span
                            className={
                              showAPValue
                                ? "badge cohort_average autopilot_variance"
                                : "d-none"
                            }
                          >
                            <span
                              className={`${getArrowIndicatorClass("isAPForcasted", showAPValue, segment)}`}
                            ></span>
                            <span className="align-middle">
                              {segment?.symbol === "$" && segment?.symbol}
                              {segment?.symbol === "$" &&
                                formatToDollar(segment?.final_AP_value)}
                              {segment?.symbol === "%" &&
                                Number(segment?.final_AP_value).toFixed(2)}
                              {segment?.symbol === "%" && segment?.symbol}
                            </span>
                          </span>
                        </CustomTooltip>
                      </>
                    )}

                    {/* <CustomTooltip text={`Forecast Variance`} placement="top">
                    <span
                      className={`badge trend ms-5 ${getDifferenceClass(
                        segment?.forecasted,
                        segment?.current,
                        segment?.is_reverse,
                      )}`}
                    >
                      {Math.abs(segment?.forcasted_trend ?? 0)}%
                    </span>
                  </CustomTooltip> */}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    )
  );
};
export default SegmentInfluencingSection;
